import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { ActionColor, Radius, Scale4 } from '../../lib/types';
import { cn } from '../../lib/utils';

type ButtonProps = Omit<HTMLArkProps<'button'>, 'color'> & {
	variant?: 'classic' | 'solid' | 'outline' | 'ghost' | 'soft' | 'surface';
	size?: Scale4;
	color?: ActionColor;
	radius?: Radius;
};

function Button({
	className,
	variant = 'solid',
	size = '2',
	color = 'accent',
	radius,
	...props
}: ButtonProps) {
	return (
		<ark.button
			data-slot="button"
			data-variant={variant}
			data-size={size}
			data-accent-color={color}
			data-radius={radius}
			className={cn('pt-button', className)}
			{...props}
		/>
	);
}

export { Button, type ButtonProps };
